export default [
	// **默认页 - 首页 1
	{
		path: "/",
		redirect: "/home",
	},

	{
		path: "/home",
		name: "Home",
		component: (resolve) => require(["@/view/home/index"], resolve),
		meta: {
			title: "平津战役纪念馆",
			keepAlive: true,
		},
	},
	// **参观指南**  111
	{
		path: "/services/visitGuide",
		component: (resolve) => require(["@/view/visitInfo/index"], resolve),
		meta: {
			title: "参观指南",
		},
	},
	// **下载中心**
	{
		path: "/services/downloadCenter",
		component: (resolve) => require(["@/view/ticket/index"], resolve),
		meta: {
			title: "下载中心",
		},
	},
	// **动态-馆内动态**
	{
		path: "/news/notice",
		name: "notice",
		component: (resolve) =>
			require(["@/view/dynamic/museumNewsList/index"], resolve),
		meta: {
			title: "通知公告",
		},
	},
	// **资讯详情 **
	{
		path: "/news/notice/detail/:id",
		component: (resolve) =>
			require(["@/view/dynamic/museumNewsDetail/index"], resolve),
		meta: {
			title: "公告详情",
		},
	},
	// **通知公告**
	{
		path: "/news/dynamic",
		component: (resolve) =>
			require(["@/view/dynamic/dynamicList/index"], resolve),
		meta: {
			title: "资讯动态",
		},
	},
	// **动态详情 **
	{
		path: "/news/dynamic/detail/:id",
		name: "dynamicDetail",
		component: (resolve) =>
			require(["@/view/dynamic/dynamicDetail/index"], resolve),
		meta: {
			title: "资讯详情",
		},
	},
	// **展览展讯** 1111
	{
		path: "/exhibition/base",
		component: (resolve) =>
			require(["@/view/exhibition/list/index"], resolve),
		meta: {
			title: "展览展讯",
			keepAlive: true,
		},
	},

	{
		path: "/exhibition/temporary",
		component: (resolve) =>
			require(["@/view/exhibition/list/index"], resolve),
		meta: {
			title: "展览展讯",
			keepAlive: true,
		},
	},
	{
		path: "/exhibition/review",
		component: (resolve) =>
			require(["@/view/exhibition/list/index"], resolve),
		meta: {
			title: "展览展讯",
			keepAlive: true,
		},
	},

	// **展览详情**
	{
		path: "/exhibitionDetail",
		component: (resolve) =>
			require(["@/view/exhibition/detail/index"], resolve),
		meta: {
			title: "展览详情",
		},
	},

	// **线上展览详情**
	{
		path: "/exhibitionOnlineDetail",
		component: (resolve) =>
			require(["@/view/exhibition/online/onlineDetail"], resolve),
		meta: {
			title: "展览详情",
		},
	},

	// **展品详情** 111
	{
		path: "/collection/boutique/detail/:id",
		name: "collectionDetail",

		component: (resolve) =>
			require(["@/view/exhibitisDetail/index"], resolve),
		meta: {
			title: "展品详情",
		},
	},

	// {
	// 	path: "*",
	// 	name: "landPage",
	// 	component: (resolve) => require(["@/view/landPage"], resolve),
	// 	meta: {
	// 		title: "landPage",
	// 	},
	// },
	// // **404
	// {
	// 	path: "/404",
	// 	name: "404",
	// 	component: (resolve) => require(["@/components/404"], resolve),
	// 	meta: {
	// 		title: "404",
	// 	},
	// },
];



// WEBPACK FOOTER //
// ./src/router/module/common.js